$(document).ready( function(){
	if ($('.accordion').length > 0){
        $(document).find('.accordion').each(function(e){
        	var dom = $(this);
        	dom.find('.accordion__item__header').on('click', function(e){
        		$(this).closest('.accordion__item').toggleClass('accordion__item--collapsed');
        		$(this).toggleClass('open');   


                if($(this).hasClass('open')) {        
                    $(this).children('.action').html('<span class="text">Collapse</span><i class="fa fa-angle-up"></i>')
                } else {        
                    $(this).children('.action').html('<span class="text">Expand</span><i class="fa fa-angle-down"></i>')
                }

        	});

        });
    }
});